var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _ellipse, _ellipse2, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 224,
    viewBox: "0 0 260 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 157,
    rx: 6,
    fill: "#EEF6FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 100,
    width: 120,
    height: 8,
    rx: 2,
    fill: "#C4E9FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 116,
    width: 120,
    height: 8,
    rx: 2,
    fill: "#C4E9FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 132,
    width: 120,
    height: 8,
    rx: 2,
    fill: "#C4E9FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 120,
    height: 71,
    rx: 4,
    fill: "#C4E9FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 16,
    width: 96,
    height: 123,
    rx: 4,
    fill: "#91D5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.78 85.02H192.34V84.1C192.34 80.46 194.58 78.58 196.7 76.94C198.5 75.5 200.14 74.14 200.14 71.82C200.14 69.1 198.46 67.3 195.66 67.3C192.82 67.3 190.86 69.42 190.86 72.5H185.78C185.78 66.78 189.98 62.74 195.78 62.74C201.74 62.74 205.34 66.18 205.34 71.5C205.34 75.78 202.58 77.82 200.26 79.46C198.3 80.86 196.78 82.06 196.78 84.1V85.02ZM194.74 93.02C192.94 93.02 191.5 91.58 191.5 89.86C191.5 88.1 192.94 86.66 194.74 86.66C196.5 86.66 197.98 88.1 197.98 89.86C197.98 91.54 196.5 93.02 194.74 93.02Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4531 223C89.4407 223 88.5879 222.243 88.4673 221.238L82.6787 173H90.6787L96.4101 220.762C96.553 221.952 95.6234 223 94.4244 223H90.4531Z",
    fill: "#F9D8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1787 173L57.3901 221.238C57.2695 222.243 56.4168 223 55.4044 223H51.4331C50.234 223 49.3044 221.952 49.4473 220.762L55.1787 173H63.1787Z",
    fill: "#F9D8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4531 223C89.4407 223 88.5879 222.243 88.4673 221.238L82.6787 173H90.6787L96.4101 220.762C96.553 221.952 95.6234 223 94.4244 223H90.4531Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1787 173L57.3901 221.238C57.2695 222.243 56.4168 223 55.4044 223H51.4331C50.234 223 49.3044 221.952 49.4473 220.762L55.1787 173H63.1787Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6787 173H48.6787C47.5741 173 46.6787 172.105 46.6787 171V167C46.6787 165.895 47.5741 165 48.6787 165H96.6787C97.7833 165 98.6787 165.895 98.6787 167V171C98.6787 172.105 97.7833 173 96.6787 173Z",
    fill: "#ECA0FA",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5987 189L83.6387 181H62.2187L61.2587 189H84.5987Z",
    fill: "#ECA0FA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6387 202.5H86.2187L87.1787 210.5H58.6787L59.6387 202.5Z",
    fill: "#ECA0FA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5987 189L83.6387 181H62.2187L61.2587 189H84.5987Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6387 202.5H86.2187L87.1787 210.5H58.6787L59.6387 202.5Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M153.563 184.193C150.395 183.983 141.679 181.5 141.679 181.5L131.679 186.5L139.984 198.411L144.219 196.403L142.212 192.167L148.455 194.395L165.399 186.364C165.399 186.364 167.897 183.883 166.178 182.536C164.115 180.92 158.57 184.524 153.563 184.193Z",
    fill: "#1D1E21"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M114.39 212.523C111.617 210.977 106.679 205 106.679 205H94.1787L96.0295 219.555H100.717V214.867L105.405 219.555H124.155C124.155 219.555 127.476 218.383 126.499 216.43C125.327 214.086 118.772 214.968 114.39 212.523Z",
    fill: "#1D1E21"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.563 184.193C150.395 183.983 141.679 181.5 141.679 181.5L131.679 186.5L139.984 198.411L144.219 196.403L142.212 192.167L148.455 194.395L165.399 186.364C165.399 186.364 167.897 183.883 166.178 182.536C164.115 180.92 158.57 184.524 153.563 184.193Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M114.39 212.523C111.617 210.977 106.679 205 106.679 205H94.1787L96.0295 219.555H100.717V214.867L105.405 219.555H124.155C124.155 219.555 127.476 218.383 126.499 216.43C125.327 214.086 118.772 214.968 114.39 212.523Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1784 160.5C47.7574 154.816 48.1784 142 48.1784 142H97.6785C104.678 143.5 106.179 144 112.678 147C118.678 150 123.678 153.5 127.678 157C135.697 164.017 142.842 172.857 145.77 176.642C146.522 177.614 146.191 179.008 145.098 179.57L131.169 186.734C130.307 187.177 129.252 186.94 128.659 186.173C126.701 183.638 122.329 178.045 119.178 174.5C115.178 170 109.57 166.5 109.57 166.5C110.333 168.809 110.764 171.461 111.178 174.5C112.399 183.453 111.633 198.036 111.305 203.154C111.239 204.197 110.371 205 109.326 205H92.6785C91.5739 205 90.6785 204.113 90.6785 203.009V178.5C90.6785 173.972 88.6452 172.042 86.1785 170.5C82.1785 168 71.1785 168 64.1785 166.5C61.2046 165.863 55.6785 165 52.1784 160.5Z",
    fill: "#CEF2BD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6785 151C80.6785 151 97.1787 155 103.178 158.5C106.655 160.528 108.463 163.152 109.57 166.5M109.57 166.5C110.333 168.809 110.764 171.461 111.178 174.5C112.399 183.453 111.633 198.036 111.305 203.154C111.239 204.197 110.371 205 109.326 205H92.6785C91.5739 205 90.6785 204.113 90.6785 203.009C90.6785 198.167 90.6785 185.651 90.6785 178.5C90.6785 173.972 88.6452 172.042 86.1785 170.5C82.1785 168 71.1785 168 64.1785 166.5C61.2046 165.863 55.6785 165 52.1784 160.5C47.7574 154.816 48.1784 142 48.1784 142L97.6785 142C104.678 143.5 106.179 144 112.678 147C118.678 150 123.678 153.5 127.678 157C135.697 164.017 142.842 172.857 145.77 176.642C146.522 177.614 146.191 179.008 145.098 179.57L131.169 186.734C130.307 187.177 129.252 186.94 128.659 186.173C126.701 183.638 122.329 178.045 119.178 174.5C115.178 170 109.57 166.5 109.57 166.5Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M78.535 76.1152C79.1466 71.2232 77.709 63.5179 77.709 63.5179C77.709 63.5179 75.5314 63.0499 74.3015 62.4853C73.0716 61.9208 71.4103 60.6267 71.4103 60.6267C71.4103 60.6267 69.2658 66.1946 67.2801 68.5775C65.7312 70.4361 62.3111 73.2736 61.3944 73.1208C60.7749 73.0175 60.1553 71.2622 59.1228 71.5719C58.0902 71.8817 57.7804 74.3599 58.0902 75.7022C58.4 77.0446 59.0195 78.7999 60.0521 79.3162C60.5544 79.5674 61.6009 79.1097 61.6009 79.1097C61.6009 79.1097 60.7749 86.7507 59.4325 91.707C60.1553 93.6689 61.4977 96.8699 63.4596 96.8699C66.3507 96.8699 68.9322 90.6745 70.9973 87.1042C71.4031 87.0709 71.8168 86.9897 72.2364 86.854C76.1686 85.5818 78.0188 80.2455 78.535 76.1152Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0791 82.7237C65.4428 84.9966 68.0074 87.3496 70.9973 87.1042M70.9973 87.1042C71.4031 87.0709 71.8168 86.9897 72.2364 86.854C76.1686 85.5818 78.0188 80.2455 78.535 76.1152C79.1466 71.2232 77.709 63.5179 77.709 63.5179C77.709 63.5179 75.5314 63.0499 74.3015 62.4853C73.0716 61.9208 71.4103 60.6267 71.4103 60.6267C71.4103 60.6267 69.2658 66.1946 67.2801 68.5775C65.7312 70.4361 62.3111 73.2736 61.3944 73.1208C60.7749 73.0175 60.1553 71.2622 59.1228 71.5719C58.0902 71.8817 57.7804 74.3599 58.0902 75.7022C58.4 77.0446 59.0195 78.7999 60.0521 79.3162C60.5544 79.5674 61.6009 79.1097 61.6009 79.1097C61.6009 79.1097 60.7749 86.7507 59.4325 91.707C60.1553 93.6689 61.4977 96.8699 63.4596 96.8699C66.3507 96.8699 68.9322 90.6745 70.9973 87.1042Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6787 93.6689C87.6787 93.6689 84.5423 92.0809 79.6787 91.0001C75.4177 90.0532 69.6177 90.7001 69.0136 90.7715C67.362 93.8232 65.4868 96.8699 63.4593 96.8699C61.4974 96.8699 60.1551 93.669 59.4323 91.7071L59.3843 91.707C59.3843 91.707 54.1986 92.1372 51.1787 93.0001C48.0491 93.8942 43.6787 95.5001 43.6787 95.5001C43.6787 95.5001 38.0174 97.2708 32.5 102C29 105 24.6875 111 27.5 120C30.0528 128.169 41.6787 134 41.6787 134H42.1787V103.5C42.1787 102.395 43.0741 101.5 44.1787 101.5H96.6787C94.1787 97.5001 87.6787 93.6689 87.6787 93.6689Z",
    fill: "#E5EEB2",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4868 76.1152C79.0983 71.2231 77.6607 63.5179 77.6607 63.5179C77.6607 63.5179 75.4832 63.0498 74.2533 62.4853C73.0234 61.9207 71.3621 60.6267 71.3621 60.6267C71.3621 60.6267 69.2175 66.1946 67.2318 68.5774C65.6829 70.4361 62.2628 73.2735 61.3461 73.1208C60.7266 73.0175 60.1071 71.2621 59.0745 71.5719C58.0419 71.8817 57.7321 74.3598 58.0419 75.7022C58.3517 77.0445 58.9712 78.7999 60.0038 79.3162C60.5062 79.5673 61.5527 79.1096 61.5527 79.1096C61.5527 79.1096 60.7266 86.7507 59.3843 91.707C59.3843 91.707 54.1986 92.1372 51.1787 93C48.0491 93.8942 43.6787 95.5 43.6787 95.5C43.6787 95.5 39.9638 92.3265 40.7429 86.1311C41.5894 79.4008 47.4713 76.7103 51.5849 70.5393C55.5934 64.526 56.273 59.8825 61.5527 54.9475C63.8725 52.7791 66.4539 51.5397 71.72 52.1596C77.5965 52.8513 80.3936 58.1485 81.2197 62.0722C81.7785 64.7266 80.8278 67.5449 81.6327 69.5067C83.2848 73.5338 87.5359 73.9468 89.8933 79.1096C93.0762 86.0808 87.6787 93.6689 87.6787 93.6689C87.6787 93.6689 84.5423 92.0808 79.6787 91C75.1787 90 68.9622 90.7777 68.9622 90.7777C69.667 89.4757 70.3311 88.1724 70.949 87.1041C71.3549 87.0708 71.7685 86.9897 72.1881 86.8539C76.1203 85.5817 77.9705 80.2455 78.4868 76.1152Z",
    fill: "#1D1E21",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2689 74.8761C73.2689 74.8761 73.4412 75.7539 73.8885 76.425C74.095 76.7347 72.9592 77.1478 72.9592 77.1478",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3779 79.8325C69.2421 79.8325 68.5521 79.4199 67.8998 78.4901",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.929313,
    cy: 1.4456,
    rx: 0.929313,
    ry: 1.4456,
    transform: "matrix(-1 0 0 1 77.1929 70.8491)",
    fill: "#1D1E21"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.929313,
    cy: 1.4456,
    rx: 0.929313,
    ry: 1.4456,
    transform: "matrix(-1 0 0 1 69.9648 70.8491)",
    fill: "#1D1E21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8231 72.0883C71.8231 74.9396 70.2975 77.2511 68.4156 77.2511C66.5337 77.2511 65.0082 74.9396 65.0082 72.0883C65.0082 69.2369 66.5337 66.9254 68.4156 66.9254C70.2975 66.9254 71.8231 69.2369 71.8231 72.0883ZM71.8231 72.0883H74.0948M74.0948 72.0883C74.0948 74.9396 75.7128 77.2511 77.7088 77.2511C79.7047 77.2511 81.3228 74.9396 81.3228 72.0883C81.3228 69.2369 79.7047 66.9254 77.7088 66.9254C75.7128 66.9254 74.0948 69.2369 74.0948 72.0883Z",
    stroke: "#B89AEB"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M36 142H44V138H36C35.4477 138 35 138.448 35 139V141C35 141.552 35.4477 142 36 142Z",
    fill: "white",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1787 101.5H103.679C104.783 101.5 105.679 102.395 105.679 103.5V140C105.679 141.105 104.783 142 103.679 142H44.1787C43.0741 142 42.1787 141.105 42.1787 140V103.5C42.1787 102.395 43.0741 101.5 44.1787 101.5Z",
    fill: "white",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.286 119.135C77.9929 119.135 78.7861 118.554 78.9714 117.286C78.2571 117.792 77.3613 117.923 76.2398 117.923C72.9113 117.923 73.0716 119.34 71.7501 120.608C71.1608 121.175 70.0111 121.253 69.7143 120.962C69.7143 121.752 70.6857 122.085 71.3217 122.085C71.9224 122.095 72.5041 121.875 72.9466 121.472C74.2181 120.24 73.8501 119.135 76.286 119.135Z",
    fill: "#1D1E21"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3219 122.091C76.3262 122.091 75.3588 122.091 74.5173 122.931C73.7879 123.661 72.8344 124.906 72.0633 124.906C70.4785 124.906 70.1808 124.158 69.2902 124.158C68.6136 124.151 68 124.578 68 125.266C68.866 124.395 70.1915 126.543 72.2314 126.543C73.4725 126.543 74.1246 125.566 74.6854 124.991C74.8119 124.864 75.6848 123.432 77.3219 123.432C78.7242 123.432 79.825 122.801 80 121.4C79.2989 122.141 78.4259 122.091 77.3219 122.091Z",
    fill: "#1D1E21"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M105.679 124C105.679 124 109.679 125 109.679 129C109.679 133 105.679 134 105.679 134V124Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M42 134C42 134 38 133 38 129C38 125 42 124 42 124V134Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.679 124C105.679 124 109.679 125 109.679 129C109.679 133 105.679 134 105.679 134V124Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M42 134C42 134 38 133 38 129C38 125 42 124 42 124V134Z",
    stroke: "#1D1E21",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyContent);
export default __webpack_public_path__ + "static/media/empty-content.c73837a9787834513e47840acdf8f20c.svg";
export { ForwardRef as ReactComponent };